module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("纯 css close 图标")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("关闭图标主要应用于弹窗(dialog)关闭按钮以及弹窗(popup)头部的关闭按钮。")])]), _vm._v(" "), _c('h2', [_vm._v("使用")]), _vm._v(" "), _c('p', [_vm._v("在你项目的"), _c('code', [_vm._v("App.vue")]), _vm._v("引入，组件内不需要再重复引入。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("lang")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"less\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }, [_vm._v("\n@import '~vux/src/styles/close.less';\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('h2', [_vm._v("类名")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("vux-close")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vux-close\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("可以参考 "), _c('code', [_vm._v("XDialog")]), _vm._v(" 演示。")]), _vm._v(" "), _c('h2', [_vm._v("颜色")]), _vm._v(" "), _c('p', [_vm._v("当你想设置图标颜色时，直接设置 color 即可。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vux-close\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"color:red;\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3bcc1d7e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-3bcc1d7e"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/close-281.vue
// module id = 2162
// module chunks = 456